import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Breadcrumb, Card, Form } from 'react-bootstrap';
import { MDBTable, MDBTableHead, MDBTableBody } from 'mdb-react-ui-kit';
import { Button } from 'primereact/button';
import '../../assets/css/calender.css';
import axios from 'axios';
import config from '../../config';
import CustomToast from '../../components/CustomToast';
import { useAuth } from '../../context/AuthContext';
const Add_brand = () => {
    const { accessToken } = useAuth();
    const [brands, setBrands] = useState([]);
    const [brandName, setBrandName] = useState('');
    const [editingBrand, setEditingBrand] = useState(null);
    const toastRef = useRef(null);

    const showMessage = (severity, detail) => {
        const summary = severity.charAt(0).toUpperCase() + severity.slice(1);
        toastRef.current.show(severity, summary, detail);
    };

    // Fetch brands on component mount
    useEffect(() => {
        fetchBrands();
    }, []);

    // Fetch all brands
    const fetchBrands = async () => {
        try {
            const response = await axios.get(`${config.apiBASEURL}/projectRoutes/fetchallbrands`,
                {
                    headers: { Authorization: `Bearer ${accessToken}` },
                });
            setBrands(response.data);
        } catch (error) {
            console.error("Error fetching brands:", error);
        }
    };

    // Handle form submission for adding or updating a brand
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            await axios.post(`${config.apiBASEURL}/projectRoutes/AddeditBrands`, {
                brand_id: editingBrand ? editingBrand.brand_id : undefined,
                brand_name: brandName,
            },
            {
                headers: { Authorization: `Bearer ${accessToken}` },
            });

            showMessage('success', editingBrand ? 'Brand Edited Successfully' : 'Brand Added Successfully');
            setBrandName('');
            setEditingBrand(null);
            fetchBrands();
        } catch (error) {
            console.error("Error saving brand:", error);
        }
    };

    // Edit brand
    const handleEdit = (brand) => {
        setEditingBrand(brand);
        setBrandName(brand.brand_name);
    };

    // // Delete brand
    // const deleteBrand = async (brandId) => {
    //     try {
    //         await axios.delete(`${config.apiBASEURL}/brandroutes/deletebrands/${brandId}`);
    //         showMessage('success', 'Brand deleted successfully');
    //         fetchBrands();
    //     } catch (error) {
    //         console.error("Error deleting brand:", error);
    //     }
    // };

    return (
        <>
            <Row className='body_content'>
                <Row className='mx-0'>
                    <Col md={6} lg={9} className='mb-4'>
                        <Breadcrumb>
                            <Breadcrumb.Item active>Brand List</Breadcrumb.Item>
                        </Breadcrumb>
                    </Col>
                    <Row className="brandPage">
                        <Col lg='4' md='12' className="pe-lg-3 ps-0">
                            <Card className="h-auto sticky-top">
                                <Card.Header><b>{editingBrand ? 'Edit Brand' : 'Add Brand'}</b></Card.Header>
                                <Card.Body>
                                    <Form onSubmit={handleSubmit}>
                                        <Col lg='12' className='mb-4'>
                                            <Card className='addEm shadow-0 p-0'>
                                                <Card.Body className='p-0'>
                                                    <Row className="mb-3">
                                                        <Col lg={12} md={12}>
                                                            <Form.Label>Brand Name <span className='text-danger'>*</span></Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Brand Name"
                                                                value={brandName}
                                                                onChange={(e) => setBrandName(e.target.value)}
                                                                required
                                                            />
                                                        </Col>
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                        <Col lg='12' className='d-flex justify-content-end'>
                                            <Button
                                                className='py-2 border-0'
                                                label={editingBrand ? 'Update' : 'Save'}
                                                icon={editingBrand ? 'pi pi-pencil' : 'pi pi-plus'}
                                                type="submit"
                                                severity="help"
                                            />
                                        </Col>
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col lg='8' md='12'>
                            <Card className='text-center h-auto'>
                                <MDBTable responsive striped hover small>
                                    <MDBTableHead light>
                                        <tr>
                                            <th scope='col'>#</th>
                                            <th scope='col'>Brand Name</th>
                                            <th scope='col'>Action</th>
                                        </tr>
                                    </MDBTableHead>
                                    <MDBTableBody>
                                        {brands.length > 0 ? (
                                            brands.map((brand, index) => (
                                                <tr key={brand.brand_id}>
                                                    <td>{index + 1}</td>
                                                    <td>{brand.brand_name}</td>
                                                    <td>
                                                        <Button
                                                            icon="pi pi-pencil"
                                                            className="p-button-rounded p-button-text p-button-primary"
                                                            onClick={() => handleEdit(brand)}
                                                        />
                                                        {/* <Button
                                                            icon="pi pi-trash"
                                                            className="p-button-rounded p-button-text p-button-danger"
                                                            onClick={() => deleteBrand(brand.brand_id)}
                                                        /> */}
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="3">No brands found</td>
                                            </tr>
                                        )}
                                    </MDBTableBody>
                                </MDBTable>
                            </Card>
                        </Col>
                        <CustomToast ref={toastRef} />
                    </Row>
                </Row>
            </Row>
        </>
    );
};

export default Add_brand;